import moment from "moment";
import { AuthApi } from "services/AuthAPI.service";
import { ACCESS_TOKEN_REFRESH_THRESHOLD } from "constant";
import { logOutSteps } from "./common.helper";
import {
  getAuthTokenExpiredTime,
  getRefreshToken,
  getRefreshTokenExpiredTime,
  getUserId,
  setAuthToken,
  setAuthTokenExpiredTime,
} from "services/Auth.service";

export const verifyAccessToken = async () => {
  const AuthApiInstance = new AuthApi();
  const refreshTokenExpiresAt = moment.unix(Number(getRefreshTokenExpiredTime()));
  const tokenExpiresAt = moment.unix(Number(getAuthTokenExpiredTime()));
  const dateTimeNow = moment().unix();
  const refreshTokenHasExpired = getRefreshTokenExpiredTime()
    ? refreshTokenExpiresAt.isBefore(moment.unix(dateTimeNow))
    : false;
  const duration = tokenExpiresAt.diff(moment.unix(dateTimeNow), "seconds");
  const user_id = getUserId();
  const refresh_token = getRefreshToken();

  const clearStore = () => {
    logOutSteps();
    window.location.href = "/login";
  };
  
  if (duration <= ACCESS_TOKEN_REFRESH_THRESHOLD && user_id && refresh_token) {
    try {
      if (duration <= 0 && refreshTokenHasExpired) {
        clearStore();
        return true;
      }

      const payload = { user_id, refresh_token };
      const response = await AuthApiInstance.refreshToken(payload);
      if (response) {
        setAuthToken(response.token);
        setAuthTokenExpiredTime(response.token_expires_at);
        return true;
      }
    } catch (error) {
      clearStore();
      return false;
    }
  }

  return true;
};
